import MDIGITAL_CONFIGURATION from './MDIGITAL_CONFIGURATION';
import MDIGITAL_LOCALIZATION from './MDIGITAL_LOCALIZATION';
import MDIGITAL_ON_PREM from './MDIGITAL_ON_PREM';
import MDIGITAL_LOGGER from './MDIGITAL_LOGGER';
import KAMPYLE_UTILS from './KAMPYLE_UTILS';
import KAMPYLE_EVENT_DISPATCHER from './KAMPYLE_EVENT_DISPATCHER';
import KAMPYLE_FUNC from './KAMPYLE_FUNC';
import KAMPYLE_CONSTANT from './KAMPYLE_CONSTANT';
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';
import KAMPYLE_DATA from './KAMPYLE_DATA';

var rateLimitCounterMap = {};
var eventMdDataKeyReplacementMap = {
    additional_data: 'additionalData',
    additionalInfo: function (val) {
        return typeof val === 'string' ? val : 'additionalData'
    },
    error_logs: 'errorLogs',
    source_function: 'sourceFunction',
    formId: 'destinationForm'
};
var eventDataKeyReplacementMap = {
    errorMessage: 'message',
    uuid: 'feedbackUuid',
    httpRequestData: 'additionalData',
    errorData: 'additionalData',
    dataObjForSbt: 'additionalData',
};

var COMMON_FIELDS;
var allDigitalEvents = {};
var nonDependentEvents = {
    neb_pageView: {
        eventId: 'nebula_page_view',
        disableProvision: KAMPYLE_CONSTANT.PROVISIONS.DISABLE_COOLADATA_NEW_PAGE_EVENTS
    },
    neb_inviteAccepted: {
        eventId: 'nebula_invite_accepted',
    },
    neb_inviteDeclined: {
        eventId: 'nebula_invite_declined',
    },
    neb_showInvitation: {
        eventId: 'nebula_invitation_show',
        memoryDataKey: 'invitationTriggeringData',
        eventDataKeys: ['additionalData'],
        ...({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData,
        }
    },
    neb_feedbackSubmitted: {
        eventId: 'nebula_form_submitted',
        ...({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData
        }
    },
    neb_formShown: {
        eventId: 'nebula_form_show',
        ...({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) && {
            formatDataFunc: appendDecibelData
        }
    },
    neb_buttonClicked: {
        eventId: 'nebula_button_clicked',
    },
    neb_sdkShowForm: {
        eventId: 'nebula_code_trigger_form',
    },
    neb_routeToForm: {
        eventId: 'nebula_route_to_form',
        eventMdDataKeys: ['formId'],
    },
    neb_formClosed: {
        eventId: 'nebula_form_closed',
    },
    neb_popupBlocked: {
        eventId: 'nebula_popup_blocked',
    },
    neb_skipInvitation: {
        eventId: 'nebula_invitation_skipped',
    },
    neb_formPageShown: {
        eventId: 'nebula_form_page_displayed',
    },
    neb_captureInit: {
        eventId: 'nebula_capture_init',
    },
    neb_captureImageClicked: {
        eventId: 'nebula_capture_image_clicked',
    },
    MDigital_Capture_Cancelled: {
        eventId: 'nebula_cancel_capture_clicked',
    },
    neb_cancel_capture_clicked: {
        eventId: 'nebula_cancel_capture_clicked',
    },
    neb_sdkSurveyDisplayed: {
        eventId: 'nebula_code_survey_displayed',
    },
    neb_afterHttpGetRequestOnError: {
        eventId: 'nebula_after_http_get_request_on_error',
        eventDataKeys: ['httpRequestData'],
    },
    neb_afterHttpGetRequestOnErrorStatusCode: {
        eventId: 'nebula_after_http_get_request_on_error_status_code',
        eventDataKeys: ['httpRequestData'],
    },
    neb_afterHttpGetRequestOnTimeout: {
        eventId: 'nebula_after_http_get_request_on_timeout',
        eventDataKeys: ['httpRequestData'],
    },
    neb_afterHttpGetRequest: {
        eventId: 'nebula_after_http_get_request',
        eventDataKeys: ['httpRequestData'],
    },
    neb_eventDispatcherError: {
        eventId: 'nebula_eventDispatcherError',
        eventDataKeys: ['errorMessage', 'errorStack', 'additionalInfo']
    },
    neb_feedbackUUIDisNull: {
        eventId: 'nebula_feedbackUuidIsNull'
    },
    neb_submitFeedbackFailed: {
        eventId: 'nebula_submitFeedbackFailed',
        eventDataKeys: ['uuid', 'errorMessage', 'errorStack']
    },
    MDigital_warning: {
        eventId: 'MDigital_warning',
        eventDataKeys: ['message']
    },
    MDigital_couldNotFetchData: {
        eventId: 'MDigital_couldNotFetchData',
        eventDataKeys: ['errorData']
    },
    MDigital_couldNotLoadFormApplication: {
        eventId: 'MDigital_couldNotLoadFormApplication',
        eventDataKeys: ['errorData']
    },
    MDigital_Invalid_Origin: {
        eventId: 'MDigital_Invalid_Origin'
    },
    MDigital_noJsonModalShown: {
        eventId: 'mdigital_noDataMessageDisplayed',
        eventMdDataKeys: ['additionalInfo']
    },
    screenCaptureRetake: {
        eventId: KAMPYLE_CONSTANT.EVENTS.SCREEN_CAPTURE_RETAKE
    },
    screenCaptureDelete: {
        eventId: KAMPYLE_CONSTANT.EVENTS.SCREEN_CAPTURE_DELETE
    },
};
var configurationDependentEvents = {
    neb_sessionStart: {
        eventId: 'session_start',
        provision: KAMPYLE_CONSTANT.PROVISIONS.ENABLE_COOLADATA_SESSION_EVENTS
    },
    neb_load_form_preload_proximity: {
        eventId: 'nebula_load_form_preload_proximity',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_button_displayed: {
        eventId: 'nebula_button_displayed',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
        eventMdDataKeys: ['position'],
    },
    neb_invitation_loaded: {
        eventId: 'nebula_invitation_loaded',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_invitation_ready: {
        eventId: 'nebula_invitation_ready',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_form_loaded: {
        eventId: 'nebula_form_loaded',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_formReady: {
        eventId: 'nebula_form_ready',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    MDigital_updatingSbtServer: {
        eventId: 'MDigital_updating_sbt_server',
        eventDataKeys: ['dataObjForSbt'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_settingIdentifierValueOnMemory: {
        eventId: 'MDigital_setting_identifier_value_on_memory',
        eventMdDataKeys: ['hasIdentifierValue'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_shouldNotSyncIdentifier: {
        eventId: 'MDigital_should_not_sync_identifier',
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_beforeHttpPostRequest: {
        eventId: 'nebula_before_http_post_request',
        eventDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnError: {
        eventId: 'nebula_after_http_post_request_on_error',
        eventDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequest: {
        eventId: 'nebula_after_http_post_request',
        eventDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnErrorStatusCode: {
        eventId: 'nebula_after_http_post_request_on_error_status_code',
        eventDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnTimeout: {
        eventId: 'nebula_after_http_post_request_on_timeout',
        eventDataKeys: ['httpRequestData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithDeclinedDateInviteDeclined: {
        eventId: 'MDigital_update_targeting_with_declined_date_invite_declined',
        eventMdDataKeys: ['declinedDate'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithSubmittedDate: {
        eventId: 'MDigital_update_targeting_with_submitted_date',
        eventMdDataKeys: ['submittedDate'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithDeclinedDateFormClosed: {
        eventId: 'MDigital_update_targeting_with_declined_date_form_closed',
        eventMdDataKeys: ['declinedDate'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_initUserIdentifier: {
        eventId: 'nebula_init_user_identifier',
        eventMdDataKeys: ['hasIdentifierValue'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_initUserIdentifierOnExtraData: {
        eventId: 'nebula_init_user_identifier_on_extra_data',
        eventMdDataKeys: ['hasIdentifierValue'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_Form_Next_Page: {
        eventId: 'MDigital_Form_Next_Page',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_Form_Back_Page: {
        eventId: 'MDigital_Form_Back_Page',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_Form_Close_No_Submit: {
        eventId: 'MDigital_Form_Close_No_Submit',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_ThankYou_Displayed: {
        eventId: 'MDigital_ThankYou_Displayed',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_ThankYou_Close: {
        eventId: 'MDigital_ThankYou_Close',
        provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_pageTargetingPhaseEnded: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_PAGE_TARGETING_PHASE_ENDED,
        provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
        formatDataFunc: formatPageTargetingData,
        eventDataKeys: ['additionalData'],
        rateLimit: 1,
    },
    MDigital_behavioralTargetingPhaseEnded: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_BEHAVIORAL_TARGETING_PHASE_ENDED,
        provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
        formatDataFunc: formatBehavioralTargetingData,
        eventDataKeys: ['additionalData'],
        rateLimit: 1,
    },
    MDigital_quarantinedSurveyPhaseEnded: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_QUARANTINED_SURVEY_PHASE_ENDED,
        provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
        formatDataFunc: formatQuarantineTargetingData,
        eventDataKeys: ['additionalData'],
        rateLimit: 1,
    },
    MDigital_DynamicOnsiteInitializedSuccessfully: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_DYNAMIC_ONSITE_INITIALIZED_SUCCESSFULLY,
        provision: KAMPYLE_CONSTANT.PROVISIONS.DYNAMIC_ONSITE_EVENTS,
    },
    MDigital_createSession: {
        eventId: KAMPYLE_CONSTANT.EVENTS.CREATE_SESSION,
        provision: KAMPYLE_CONSTANT.PROVISIONS.CREATE_SESSION,
        eventDataKeys: ['additionalData']
    },
    mdigital_customEventsDebugMessage: {
        eventId: KAMPYLE_CONSTANT.EVENTS.CUSTOM_EVENTS_DEBUG_MESSAGE,
        eventDataKeys: ['customEventId', 'customEventData'],
        provision: KAMPYLE_CONSTANT.PROVISIONS.ENABLE_EVENTS_FOR_CE_DEBUG
    },
    MDigital_CHTML_Logs: {
        eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_CHTML_LOGS,
        provision: KAMPYLE_CONSTANT.PROVISIONS.CHTML_LOGS,
        eventMdDataKeys: ['source_function', 'additional_data', 'error_logs']
    },
};
Object.assign(allDigitalEvents, nonDependentEvents);

function appendDecibelData(payload) {
    var formData = KAMPYLE_DATA.getFormData(payload.formId);
    var decibelBehavioural = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelBehavioural');
    var decibelScore = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelScore');

    if (decibelBehavioural) {
        KAMPYLE_UTILS.setNestedPropertyValue(payload, 'decibelBehavioural', decibelBehavioural.eventName);
    }

    if (decibelScore) {
        var decibelData = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DECIBEL_DATA);
        KAMPYLE_UTILS.setNestedPropertyValue(payload, 'decibelScore', {
            eventName: decibelScore.eventName,
            score: decibelData[decibelScore.eventName]
        });
    }
    return payload;
}

function initRateLimiting(specificEvents) {
    var events = specificEvents || allDigitalEvents;
    Object.keys(events).forEach(function (ev) {
        var eventObj = events[ev];
        if (isEventDefinedAsRateLimited(eventObj)) {
            rateLimitCounterMap[eventObj.eventId] = 0;
        }
    });
}

function getDataToSend(dataFormatted) {
    var feedbackUUID = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.BACKEND_GENERATED_UUID) ? dataFormatted.feedbackUUID : dataFormatted.feedbackCorrelationUUID;

    if (!dataFormatted.accountId) {
        KAMPYLE_EVENT_DISPATCHER.appendDefaultEventParams(dataFormatted);
    }
    const isTargetingEventsReporting = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING);

    var dataToSend = {
        accountId: dataFormatted.accountId,
        propertyId: dataFormatted.websiteId,
        feedbackUuid: feedbackUUID,
        formId: dataFormatted.formId || null,
        formTriggerType: KAMPYLE_DATA.getFormTriggerType(dataFormatted.formId),
        mdData: dataFormatted.mdData || {},
        userId: dataFormatted.userId || null,
        sessionId: dataFormatted.sessionId || null,
        cookieSize: dataFormatted.cookieSize || null,
        sdkVersion: window.MDIGITAL.version || '0.0.0.0',
        historyLength: window.history.length,
        isUserIdentified: !!KAMPYLE_DATA.getMemoryData('identifierValue'),
        feedbackCorrelationUuid: KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.BACKEND_GENERATED_UUID) ? dataFormatted.feedbackCorrelationUUID : null,
    };

    if ({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) {
        if (dataFormatted.decibelBehavioural) {
            Object.assign(dataToSend.mdData, {
                decibelBehavioural: dataFormatted.decibelBehavioural
            });
        }
        if (dataFormatted.decibelScore) {
            Object.assign(dataToSend.mdData, {
                decibelScore: dataFormatted.decibelScore
            });
        }
    }

    if (dataFormatted.formId) {
        dataToSend.webFormLang = MDIGITAL_LOCALIZATION.getFormLanguage(dataFormatted.formId) || null;
    }
    if ({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isOnPremEnabled) {
        dataToSend.packageVersion = MDIGITAL_ON_PREM.getPackageVersion();
    }

    addEventDataKeys(dataFormatted, dataToSend);

    if (isTargetingEventsReporting && dataFormatted.targetingData) {
        dataToSend.additionalData = {
            ...dataToSend.additionalData,
            mdTargetingData: dataFormatted.targetingData,
            mdEventUuid: KAMPYLE_UTILS.kampyleCreateUUID()
        }
    }

    return dataToSend;
}

function addEventDataKeys(dataFormatted, dataToSend) {
    var digitalEvent = allDigitalEvents[dataFormatted.eventName];
    var eventDataKeys = digitalEvent ? digitalEvent.eventDataKeys : null;
    if (eventDataKeys) {
        for (var i = 0; i < eventDataKeys.length; i++) {
            var eventDataKeyName = eventDataKeyReplacementMap[eventDataKeys[i]] || eventDataKeys[i];
            dataToSend[eventDataKeyName] = dataFormatted[eventDataKeys[i]] || null;
        }
    }
}

function sendDigitalAnalytics(dataFormatted) {
    if (!dataFormatted || !window.kampyle) {
        return false;
    }
    var dataToSend = getDataToSend(dataFormatted);
    MDIGITAL_ANALYTICS.makeAnalyticsCalls(dataFormatted.eventId, dataToSend);
    return true;
}

function formatData(eventName, oData) {
    if (!eventName || !oData) {
        return null;
    }

    var result = Object.assign({}, oData);

    //fill with defaults
    for (var prop in COMMON_FIELDS) {
        result[prop] = COMMON_FIELDS[prop];
    }

    //Fill with event specific variables
    for (var eventProp in allDigitalEvents[eventName]) {
        result[eventProp] = allDigitalEvents[eventName][eventProp];
    }

    var digitalData = KAMPYLE_UTILS.getAllKampyleData();
    result.mdData = {
        SUBMITTED_DATE: digitalData.SUBMITTED_DATE,
        DECLINED_DATE: digitalData.DECLINED_DATE,
        LAST_INVITATION_VIEW: digitalData.LAST_INVITATION_VIEW,
        mdUserPercentile: digitalData.kampyleUserPercentile,
        mdInvitePresented: digitalData.kampyleInvitePresented,
    }

    appendMemoryDataByEventName(eventName, result);
    appendMdDataByEventName(eventName, result.mdData, result);

    result.sessionId = digitalData.kampyleUserSession;
    result.cookieSize = KAMPYLE_UTILS.getByteSize(document.cookie);
    result.pageURL = location.href;
    result.eventName = eventName;
    return result;
}

var triggerDigitalEvent = function (eventName, oData) {
    var eventObj = allDigitalEvents[eventName];
    if (!(eventObj && isEventProvisioned(eventObj)) || isRateLimitExceeded(eventObj)) {
        return false;
    }

    var shouldFormatEventData = eventObj.formatDataFunc && typeof eventObj.formatDataFunc === 'function';
    if (shouldFormatEventData) {
        oData = eventObj.formatDataFunc.call(this, oData);
    }

    var oDataFormatted = formatData(eventName, oData);

    MDIGITAL_ANALYTICS.sendDigitalAnalytics(oDataFormatted);
}

function isEventProvisioned(eventObj) {
    var isDisabled = eventObj.disableProvision && KAMPYLE_FUNC.checkProvision(eventObj.disableProvision);
    return !isDisabled && (!eventObj.provision || !!KAMPYLE_FUNC.checkProvision(eventObj.provision)); // Support backwards compatibility
}

function isEventDefinedAsRateLimited(eventObj) {
    return typeof eventObj.rateLimit === 'number' && eventObj.rateLimit > 0;
}

function getEventCallsCounter(eventId) {
    var counter = rateLimitCounterMap[eventId];
    return typeof counter === 'number' ? counter : null;
}

function isRateLimitExceeded(eventObj) {
    var counter = getEventCallsCounter(eventObj.eventId);
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.COOLADATA_EVNETS_LIMIT) && typeof counter === 'number' && counter >= eventObj.rateLimit;
}

function increaseEventCallsCounter(eventId) {
    if (getEventCallsCounter(eventId) === null) {
        return null;
    }
    return ++(rateLimitCounterMap[eventId]);
}

function triggerDigitalAnalyticsEventDispatcherError(eventData) {
    if (!eventData || !window.kampyle) {
        return false;
    }
    var dataFormatted = formatData('neb_eventDispatcherError', eventData);
    var dataToSend = getDataToSend(dataFormatted);
    MDIGITAL_ANALYTICS.makeAnalyticsCalls(dataFormatted.eventId, dataToSend);
    return dataToSend;
}

function makeAnalyticsCalls(eventId, dataToSend) {
    try {
        window.kampyle.trackEvent(eventId, dataToSend);
        getEventCallsCounter(eventId) !== null && increaseEventCallsCounter(eventId);
    } catch (e) {
        console.warn(e);
    }
}

function initBaseTracker() {
    try {
        COMMON_FIELDS = {
            userId: KAMPYLE_UTILS.kampyleGetUserId(),
        };

        try {
            if (!window.kampyle){
              /** This will register basic functions that used to send events to the server,
               * so we can now call kampyle.trackEvent. The events will be sent only after the full tracker will be loaded!
               * We must call init in order to register the basic functions (trackEvent, trackEventLater, set_config...)
               */
              /* eslint-disable-next-line no-control-regex, no-inner-declarations, no-cond-assign */
              (function(d,a){if(!a.__SV){var g,e;window.kampyle=a;a._i=[];a.init=function(b,f){function d(a,b){var c=b.split('.');2==c.length&&(a=a[c[0]], b = c[1]);a[b]=function(){a.push([b].concat(Array.prototype.slice.call(arguments,0)));};}var h=a;'undefined'!==typeof f?h=a[f]=[]:f='kampyle';g=['trackEvent','trackEventLater','trackPageload','flush','set_config'];for(e=0;e<g.length;e++) d(h,g[e]);a._i.push([b,f]);};a.__SV=1.2;}})(document, window.kampyle || []);
            }
            window.kampyle.init()

            if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.COOLADATA_EVNETS_LIMIT)) {
                initRateLimiting(nonDependentEvents);
                KAMPYLE_EVENT_DISPATCHER.subscribeOnce(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_SDK_PAGE_VIEW, initRateLimiting);
            }
        } catch (e) {
            console.warn(e);
        }
        KAMPYLE_UTILS.initEventSubscriptions(nonDependentEvents, triggerDigitalEvent);
        return true;
    } catch (e) {
        console.warn(e);
    }
}

function loadFullTracker() {
    var onsiteData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    if (onsiteData && onsiteData.analyticsSubmitEventsUrl) {
        var tracker_config = {
            api_host: onsiteData.analyticsSubmitEventsUrl,
            topic: onsiteData.mecIntegrationId
        };
      window.kampyle.set_config(tracker_config);
      /** This will take the collected events and send them to api_host, with the header Md-Integration-Id (topic)
       *  and will send POST xhr for every event called by trackEvent immediately. It adds some extra info:
       *  sessionScreenSize, sessionDua, sessionPlatform, referringUrl, pageTitle, pageUrl, type, timestamp, eventTimezoneOffset
       */
      /* eslint-disable-next-line no-control-regex, no-inner-declarations, no-cond-assign, no-self-assign */
      !function(e){var t,n=Array.prototype,r=Object.prototype,o=n.slice,i=r.toString,a=r.hasOwnProperty,s=window.console,c=window.navigator,u=window.document,f=c.userAgent;c.userAgentData&&c.userAgentData.platform&&(t=c.userAgentData.getHighEntropyValues(["architecture","bitness","model","platformVersion","uaFullVersion","fullVersionList","wow64"]).then(JSON.stringify));var l,d,p,h,_="kampyle",y=e&&e.__SV||0,g=window.XMLHttpRequest&&"withCredentials"in new XMLHttpRequest,v=!g&&-1==f.indexOf("MSIE")&&-1==f.indexOf("Mozilla"),m={},S={api_host:"",loaded:function(){},http_post:!0},w=!1;l=n.forEach,d=Array.isArray,p={},h=m.each=function(e,t,n){if(null!=e)if(l&&e.forEach===l)e.forEach(t,n);else if(e.length===+e.length){for(var r=0,o=e.length;r<o;r++)if(r in e&&t.call(n,e[r],r,e)===p)return}else for(var i in e)if(a.call(e,i)&&t.call(n,e[i],i,e)===p)return},m.extend=function(e){return h(o.call(arguments,1),(function(t){for(var n in t)void 0!==t[n]&&(e[n]=t[n])})),e},m.isArray=d||function(e){return"[object Array]"===i.call(e)},m.isFunction=function(e){try{return/^\s*\bfunction\b/.test(e)}catch(e){return!1}},m.isArguments=function(e){return!(!e||!a.call(e,"callee"))},m.toArray=function(e){return e?e.toArray?e.toArray():m.isArray(e)||m.isArguments(e)?o.call(e):m.values(e):[]},m.values=function(e){var t=[];return null==e||h(e,(function(e){t[t.length]=e})),t},m.isObject=function(e){return e===Object(e)&&!m.isArray(e)},m.isUndefined=function(e){return void 0===e},m.isString=function(e){return"[object String]"==i.call(e)},m.strip_empty_properties=function(e){var t={};return m.each(e,(function(e,n){m.isString(e)&&e.length>0&&(t[n]=e)})),t},m.base64Encode=function(e){var t={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var n,r,o,i,a,s,c,u="",f=0;for(e=t._utf8_encode(e);f<e.length;)i=(n=e.charCodeAt(f++))>>2,a=(3&n)<<4|(r=e.charCodeAt(f++))>>4,s=(15&r)<<2|(o=e.charCodeAt(f++))>>6,c=63&o,isNaN(r)?s=c=64:isNaN(o)&&(c=64),u=u+this._keyStr.charAt(i)+this._keyStr.charAt(a)+this._keyStr.charAt(s)+this._keyStr.charAt(c);return u},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");for(var t="",n=0;n<e.length;n++){var r=e.charCodeAt(n);r<128?t+=String.fromCharCode(r):r>127&&r<2048?(t+=String.fromCharCode(r>>6|192),t+=String.fromCharCode(63&r|128)):(t+=String.fromCharCode(r>>12|224),t+=String.fromCharCode(r>>6&63|128),t+=String.fromCharCode(63&r|128))}return t}};return t.encode(e)},m.utf8Encode=function(e){e=e.replace(/\r\n/g,"\n");for(var t="",n=0;n<e.length;n++){var r=e.charCodeAt(n);r<128?t+=String.fromCharCode(r):r>127&&r<2048?(t+=String.fromCharCode(r>>6|192),t+=String.fromCharCode(63&r|128)):(t+=String.fromCharCode(r>>12|224),t+=String.fromCharCode(r>>6&63|128),t+=String.fromCharCode(63&r|128))}return t},m.HTTPBuildQuery=function(e,t){var n,r,o=[];return void 0===t&&(t="&"),m.each(e,(function(e,t){n=encodeURIComponent(e.toString()),r=encodeURIComponent(t),o[o.length]=r+"="+n})),o.join(t)},m.getQueryParam=function(e,t){t=t.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var n=new RegExp("[\\?&]"+t+"=([^&#]*)").exec(e);return null===n||n&&"string"!=typeof n[1]&&n[1].length?"":decodeURIComponent(n[1]).replace(/\+/g," ")},m.register_event=function(){function e(t){return t&&(t.preventDefault=e.preventDefault,t.stopPropagation=e.stopPropagation),t}return e.preventDefault=function(){this.returnValue=!1},e.stopPropagation=function(){this.cancelBubble=!0},function(t,n,r,o){if(t)if(t.addEventListener&&!o)t.addEventListener(n,r,!1);else{var i="on"+n,a=t[i];t[i]=function(t,n,r){var o=function(o){if(o=o||e(window.event)){var i,a,s=!0;return m.isFunction(r)&&(i=r(o)),a=n.call(t,o),!1!==i&&!1!==a||(s=!1),s}};return o}(t,r,a)}else s.log("No valid element provided to register_event")}}(),m.info={properties:function(){return m.extend(m.strip_empty_properties({sessionScreenSize:window.screen.width+"x"+window.screen.height,sessionDua:c.userAgent,sessionPlatform:c.platform,referringUrl:u.referrer,pageTitle:u.title,pageUrl:u.location.href}),{type:"website"})}};var A=function(){if(!m.isUndefined(s)&&s){var e=["Kampyle error:"].concat(m.toArray(arguments));try{s.error.apply(s,e)}catch(t){m.each(e,(function(e){s.error(e)}))}}},C=function(t,n){var r,o=n===_?e:e[n];if(!o||m.isArray(o))return(r=new E)._init(t,n),m.isUndefined(o)||r._execute_array(o),r;s.log("You have already initialized "+n)},E=function(){};if(E.prototype.init=function(t,n){if(void 0!==n){if(n!==_){var r=C(t,n);return e[n]=r,r._loaded(),r}s.log("You must initialize the main kampyle object right after you include the Kampyle js snippet")}else s.log("You must name your new library: init(config, name)")},E.prototype._init=function(e,t){this.__loaded=!0,this.__SV=!0,this.config={},this.eventsArray=[],e=e||{},this.set_config(m.extend({},S,{session_id:e.session_id,http_post:e.http_post,topic:e.topic,name:t,api_host:e.api_host})),this.__dom_loaded_queue=[],this.__request_queue=[],e.custom_event_handler&&(this.__customEventHandler=e.custom_event_handler)},E.prototype._loaded=function(){this.get_config("loaded")(this)},E.prototype._dom_loaded=function(){m.each(this.__dom_loaded_queue,(function(e){this._track_dom.apply(this,e)}),this),m.each(this.__request_queue,(function(e){this._send_request.apply(this,e)}),this),delete this.__dom_loaded_queue,delete this.__request_queue},E.prototype._track_dom=function(e,t){if(!w)return this.__dom_loaded_queue.push([e,t]),!1;var n=(new e).init(this);return n.track.apply(n,t)},E.prototype.trackEventLater=function(e,n){if(void 0!==e){n=n||{};var r=new Date,o=m.extend({},m.info.properties(),{eventName:e,timestamp:r.toISOString(),eventTimezoneOffset:r.getTimezoneOffset()/60*-1});if(o=m.extend(o,n),t){var i=this;t.then((function(e){o=m.extend(o,{clientHints:e})})).finally((function(){i.eventsArray.push(o)}))}else this.eventsArray.push(o)}else s.log("No event name provided to kampyle.trackEventLater")},E.prototype.flush=function(){var e=this.eventsArray;this._send_request(e),this.eventsArray=[]},E.prototype._onError=function(e,t){},E.prototype._send_request=function(e,t){if(v)this.__request_queue.push(arguments);else{if(this.__customEventHandler&&this.__customEventHandler.handleRequest){var n=null;return g&&(n="post"),void this.__customEventHandler.handleRequest(this,e,n)}var r=this.get_config("api_host"),o=this.get_config("topic"),i=JSON.stringify(e);if(g){var a=new XMLHttpRequest;a.open("POST",r,!0),a.setRequestHeader("Content-type","application/json"),a.setRequestHeader("charset","UTF-8"),o&&a.setRequestHeader("Mec-Integration-Id",o),a.onreadystatechange=function(e){if(4===a.readyState)if(200===a.status)t&&t();else{var n="Bad HTTP status: "+a.status+" "+a.statusText;s.log(n)}},a.send(i)}else{var c=this;e={data:m.base64Encode(i)},o&&(e.mecIntegrationId=m.base64Encode(o)),r+="/da.gif?"+m.HTTPBuildQuery(e);var f=u.createElement("img");f.onerror=function(){c._onError(e,t)},f.width=1,f.height=1,f.src=r}}},E.prototype._execute_array=function(e){var t,n=[],r=[],o=[];m.each(e,(function(e){e&&(t=e[0],"function"==typeof e?e.call(this):m.isArray(e)&&"alias"===t?n.push(e):!m.isArray(e)||-1==t.indexOf("track")&&-1==t.indexOf("flush")||"function"!=typeof this[t]?r.push(e):o.push(e))}),this);var i=function(e,t){m.each(e,(function(e){this[e[0]].apply(this,e.slice(1))}),t)};i(n,this),i(r,this),i(o,this)},E.prototype.push=function(e){this._execute_array([e])},E.prototype.trackEvent=function(e,n,r){if(void 0!==e){n=n||{};var o=new Date,i=m.extend({},m.info.properties(),{eventName:e,timestamp:o.toISOString(),eventTimezoneOffset:o.getTimezoneOffset()/60*-1});i=m.extend(i,n),t?t.then((function(e){i=m.extend(i,{clientHints:e})})).finally(this._send_events.bind(this,i,r)):this._send_events(i,r)}else s.log("No event name provided to kampyle.trackEvent")},E.prototype._send_events=function(e,t){this._send_request([e],t)},E.prototype.set_config=function(e){m.isObject(e)&&m.extend(this.config,e)},E.prototype.get_config=function(e){return this.config[e]},E.prototype.toString=function(){var e=this.get_config("name");return e!==_&&(e=_+"."+e),e},m.toArray=m.toArray,m.isObject=m.isObject,m.info=m.info,E.prototype.init=E.prototype.init,E.prototype.track_event=E.prototype.trackEvent,E.prototype.track_event_later=E.prototype.trackEventLater,E.prototype.flush=E.prototype.flush,E.prototype.set_config=E.prototype.set_config,E.prototype.get_config=E.prototype.get_config,E.prototype.toString=E.prototype.toString,m.isUndefined(e))A("'kampyle' object not initialized. Ensure you are using the latest version of the Kampyle JS Library along with the snippet we provide.");else if(e.__loaded||e.config)s.log("Kampyle library has already been downloaded at least once.");else if(y<1.1)s.critical("Version mismatch; please ensure you're using the latest version of the Kampyle code snippet.");else{var b={};m.each(e._i,(function(e){var t,n;e&&m.isArray(e)&&(t=e[e.length-1],n=C.apply(this,e),b[t]=n)}));if(e.init=function(t,n){if(n)e[n]||(e[n]=b[n]=C(t,n),e[n]._loaded());else{var r=e;b[_]?r=b[_]:(r=C(t,_))&&r._loaded(),window[_]=e=r,m.each(b,(function(t,n){n!==_&&(e[n]=t)})),e._=m}},e.init(),m.each(b,(function(e){e._loaded()})),u.addEventListener)"complete"==u.readyState?k():u.addEventListener("DOMContentLoaded",k,!1);else if(u.attachEvent){u.attachEvent("onreadystatechange",k);var q=!1;try{q=null==window.frameElement}catch(e){}if(u.documentElement.doScroll&&q){!function e(){try{u.documentElement.doScroll("left")}catch(t){return void setTimeout(e,1)}k()}()}}m.register_event(window,"load",k,!0)}function k(){k.done||(k.done=!0,w=!0,v=!1,m.each(b,(function(e){e._dom_loaded()})))}}(window.kampyle);
    } else {
        console.error(new Error('No Digital analytics url was found!'))
    }

}

function registerConfigurationDependentEvents() {
    Object.assign(allDigitalEvents, configurationDependentEvents);
    initRateLimiting(configurationDependentEvents);
    KAMPYLE_UTILS.initEventSubscriptions(configurationDependentEvents, triggerDigitalEvent);
}

function appendMemoryDataByEventName(eventName, eventJsonData) {
    eventJsonData = eventJsonData || {};
    var memoryDataKey = allDigitalEvents[eventName].memoryDataKey;
    var memoryData = KAMPYLE_DATA.getMemoryData(memoryDataKey);
    if (memoryData) {
        eventJsonData.additionalData = eventJsonData.additionalData || {};
        eventJsonData.additionalData[memoryDataKey] = memoryData;
    }
    return eventJsonData;
}

function appendMdDataByEventName(eventName, mdDataObj, eventJsonData) {
    eventJsonData = eventJsonData || {};
    var eventMdDataKeys = allDigitalEvents[eventName].eventMdDataKeys;
    if (eventMdDataKeys) {
        for (var i = 0; i < eventMdDataKeys.length; i++) {
            var eventMdDataKey = eventMdDataKeys[i];
            var eventData = eventJsonData[eventMdDataKey];
            var eventMdDataKeyName = eventMdDataKeyReplacementMap[eventMdDataKey] || eventMdDataKey;
            if (typeof eventMdDataKeyName === 'function') {
                eventMdDataKeyName = eventMdDataKeyName(eventData);
            }
            mdDataObj[eventMdDataKeyName] = eventData;
        }
    }
    return mdDataObj;
}

function getFinalConditionResult(accumulator, current) {
    return accumulator && current.isPassed;
}

function getFormTargetingData(form, targetingPhase) {
    form = form || {};
    var formState = KAMPYLE_DATA.getFormState(form.formId);
    if (!formState || !formState.targeting) {

        MDIGITAL_LOGGER.error("Digital Analytics - getFormTargetingData: failed to build " + targetingPhase + " phase data for form id: " + form.id);

        return false;
    }

    var conditions = formState.targeting[targetingPhase];
    var dataToSend = {
        formId: form.formId,
        formType: form.formType,
        evaluationResult: conditions === null ? false : (conditions || []).reduce(getFinalConditionResult, true),
        conditions: conditions
    };

    return dataToSend;
}

function formatPageTargetingData() {
    var dataToSend = [];
    var allForms = KAMPYLE_DATA.getAllForms() || [];
    allForms.forEach(function (form) {
        dataToSend.push(getFormTargetingData(form, KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING));
    });
    return {mdTargetingData: dataToSend};
}

function formatBehavioralTargetingData(formData) {
    return {mdTargetingData: getFormTargetingData(formData, KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING)};
}

function formatQuarantineTargetingData(formData) {
    var form = getFormTargetingData(formData, KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING) || {};
    form.hasUserIdentifier = !!KAMPYLE_DATA.getMemoryData('identifierValue');
    form.userIdentifierValue = KAMPYLE_DATA.getMemoryData('identifierValue');
    return {mdTargetingData: form};
}

export default {
    //for testing
    getDataToSend: getDataToSend,
    sendDigitalAnalytics: sendDigitalAnalytics,
    formatData: formatData,
    appendDataByEventName: appendMdDataByEventName,
    appendMemoryDataByEventName: appendMemoryDataByEventName,
    addEventDataKeys: addEventDataKeys,
    makeAnalyticsCalls: makeAnalyticsCalls,
    rateLimitCounterMap: rateLimitCounterMap,

    isEventProvisioned: isEventProvisioned,
    isEventDefinedAsRateLimited: isEventDefinedAsRateLimited,
    getEventCallsCounter: getEventCallsCounter,
    isRateLimitExceeded: isRateLimitExceeded,
    increaseEventCallsCounter: increaseEventCallsCounter,
    initRateLimiting: initRateLimiting,

    initBaseTracker: initBaseTracker,
    loadFullTracker: loadFullTracker,
    registerConfigurationDependentEvents: registerConfigurationDependentEvents,
    triggerDigitalEvent: triggerDigitalEvent,
    triggerDigitalAnalyticsEventDispatcherError: triggerDigitalAnalyticsEventDispatcherError,
    formatPageTargetingData: formatPageTargetingData,
    formatBehavioralTargetingData: formatBehavioralTargetingData,
    formatQuarantineTargetingData: formatQuarantineTargetingData,
    getFormTargetingData: getFormTargetingData
};
